import clsx from 'clsx'
import { ChevronDownIcon, LogOutIcon, UserCircleIcon } from 'lucide-react'

import { useLogout } from 'components/hooks/useLogout'
import { DropdownMenu } from 'slab'

import { useEmployer } from './EmployerProvider'

export function EmployerMenu () {
  const { employer } = useEmployer()
  const { mutate: logout } = useLogout()

  if (!employer) {
    return null
  }

  const trigger = (
    <button
      className={clsx(
        'appearance-none flex items-center gap-1 rounded-lg p-2 body text-gray-800 hover:bg-gray-100 focus-visible:bg-gray-100 data-[state*="open"]:bg-gray-200 data-[state*="open"]:hover:bg-gray-200 data-[state*="open"]:focus-visible:bg-gray-200 outline outline-offset-2 outline-2 outline-transparent focus-visible:outline-thatch-500'
      )}
    >
      <ChevronDownIcon aria-hidden size={16} />
      <UserCircleIcon aria-hidden size={24} />
    </button>
  )

  return (
    <div className='flex h-6 items-center'>
      <DropdownMenu align='end' trigger={trigger}>
        <DropdownMenu.Item leftIcon={LogOutIcon} onSelect={() => logout()}>
          Save and sign out
        </DropdownMenu.Item>
      </DropdownMenu>
    </div>
  )
}
